// Generated by CoffeeScript 2.7.0
import core from './core.js';

import transmit from './transmit.js';

core.init('witness');

export default {
	record: transmit.sendMore,
	get viewId() { return transmit.viewId; },
};
